"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CO = void 0;
exports.CO = {
    belongsToEU: false,
    belongsToEurope: false,
    subdivisions: {
        'CO-AMA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-ANT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-ARA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-ATL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-BOL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-BOY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CAL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CAQ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CAS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CAU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CES': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CHO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-COR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-CUN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-GUA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-GUV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-HUI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-LAG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-MAG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-MET': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-NAR': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-NSA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-PUT': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-QUI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-RIS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-SAN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-SAP': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-SUC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-TOL': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-VAC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-VAU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-VID': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'CO-DC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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